<template>
  <div class="image-upload-info-container">
    <el-upload
      :class="{ uploadContainer: hideAddDiv }"
      :action="`${env.VUE_APP_fileserver}persistentUpload`"
      list-type="picture-card"
      :limit="limit"
      :file-list="fileList"
      :on-success="uploadSuccess"
      :on-remove="pictureRemove"
      :before-upload="pictureBeforeUpload"
    >
      <i class="el-icon-plus"></i>
    </el-upload>
  </div>
</template>

<script>
export default {
  props: {
    limit: {
      type: Number,
      default: 10,
    },
    sizeLimit: {
      type: Number,
      default: 0.3,
    },
  },
  data() {
    return {
      env: process.env,
      fileList: [],
    };
  },
  computed: {
    hideAddDiv() {
      return this.fileList.length >= this.limit;
    },
  },
  methods: {
    uploadSuccess(res) {
      const {
        data: { name, url },
      } = res;
      const item = {
        name: name || "",
        url: url || "",
      };

      this.fileList.push(item);
      console.log("上传图片成功之后", this.fileList);
    },
    pictureRemove(file) {
      this.fileList = this.fileList.filter((item) => item.uid !== file.uid);
      console.log("移除图片", this.fileList);
    },
    pictureBeforeUpload(file) {
      const typeArr = ["image/png", "image/jpg", "image/jpeg"];

      if (!typeArr.includes(file.type)) {
        this.$message.error("上传图片只能是 JPG、JPEG、PNG 格式!");
        return false;
      }

      if (file.size > this.sizeLimit * 1024 * 1024) {
        let unitStr = this.sizeLimit >= 1 ? `${this.sizeLimit}M` : `${this.sizeLimit * 1000}KB`;
        this.$message.error(`图片不能大于${unitStr}`);
        return false;
      }
      this.isShowProgress = true;
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.image-upload-info-container {
  .uploadContainer {
    ::v-deep .el-upload--picture-card {
      display: none;
    }
  }
}
</style>
